import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import s from './error-page.scss'

export const ErrorPage = () => {
  const {isViewer} = useEnvironment()
  const {t} = useTranslation()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    window.location.reload()
  }

  return (
    <div dir="ltr" id="events-error-screen">
      <div className={s.container}>
        <div className={s.box}>
          <h2 className={s.title}>{t('detailsPage.errorState.title')}</h2>
          <p className={s.subtitle}>{t('detailsPage.errorState.subtitle')}</p>
          {isViewer ? (
            <button className={s.button} onClick={handleClick}>
              {t('detailsPage.errorState.button')}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
